import List16 from '@carbon/icons-react/es/list/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { PanelHeaderTitle } from 'components/atoms/collapse';
import { IconShell } from 'components/atoms/icon-shell';

export const TaskFieldsTitle: FC = () => (
  <PanelHeaderTitle
    icon={<IconShell icon={<List16 />} />}
    title={<FormattedMessage id="task_fields" />}
  />
);
